const HEX_COLOR = /^#([0-9a-f]{6})$/i;

const AA_NORMAL_TEXT = 4.5;
export const AA_LARGE_TEXT = 3;

const channelLuminance = (channel: number): number => {
  const value = channel / 255;
  return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
};

const relativeLuminance = (hex: string): number => {
  const match = HEX_COLOR.exec(hex);
  if (!match?.[1]) throw new RangeError(`Expected a #RRGGBB colour, received ${hex}`);
  const value = Number.parseInt(match[1], 16);
  const red = channelLuminance((value >> 16) & 0xff);
  const green = channelLuminance((value >> 8) & 0xff);
  const blue = channelLuminance(value & 0xff);
  return 0.2126 * red + 0.7152 * green + 0.0722 * blue;
};

export const contrastRatio = (foreground: string, background: string): number => {
  const [lighter, darker] = [relativeLuminance(foreground), relativeLuminance(background)].sort(
    (a, b) => b - a,
  );
  return ((lighter ?? 0) + 0.05) / ((darker ?? 0) + 0.05);
};

export const meetsAaContrast = (
  foreground: string,
  background: string,
  threshold = AA_NORMAL_TEXT,
): boolean => contrastRatio(foreground, background) >= threshold;
